import React from 'react';
import classes from './styles.module.css'

const Container = ({direction, ...props}) => {
    return (
        <div className={direction === 'column' ? `${classes.container} ${classes.column}` : `${classes.container}`} {...props} />
    );
};

export default Container;